import { showFailedOperationToast, showSuccessOperationToast } from '@/composables/toast'

export const copyToBuffer = text => {
  navigator.clipboard.writeText(text).then(
    () => showSuccessOperationToast('Текст успешно скопирован'),
    () => showFailedOperationToast('Не удалось скопировать текст')
  )
}
